
import axios from 'axios'
import store from '@/store'

const CancelToken = axios.CancelToken
let cancels = {}
let cachedDatas = {}

function cancelRequest (id) {
  console.log("Should cancel ",id, '?')
  if(cancels[id]) console.log("-> INDEED, canceling...")
  else console.log("-> NO, not fond in cancels: ",cancels)
  if (cancels[id]) cancels[id]()
  cancels[id] = null
}

let cancelableInstance = axios.create({
  baseURL: '',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

cancelableInstance.interceptors.request.use(config => {
  let reqId = config.reqId//.split('?')[0]
  if(!config.avoidCancel) {
    cancelRequest(reqId)
    config.cancelToken = new CancelToken(c => (cancels[reqId] = c))
  }
    return config
})
cancelableInstance.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (axios.isCancel(error)) console.log('Request canceled')
    else throw error
  }
)


////////////////////

function objToQuery(params) {
  return Object.keys(params).filter(key => params[key]).map(key => key + '=' + params[key]).join('&');
}

function getIndicatorData (id, filters, options={}) {
  // console.log("Should call API for:",id,filters, store.state)
  // console.log("getIndicatorData: ",id,store.state.nodeInfo.glk)
  console.log(`API -----> fetching data for ${id} / ${store.state.nodeInfo.glk}`)
  let sector, nationality, group
  let sectorKey = Object.keys(filters).find((d)=>d.indexOf('sector')>=0)
  if(sectorKey) sector = filters[sectorKey]
  
  let groupKey = Object.keys(filters).find((d)=>d.indexOf('group')>=0)
  if(groupKey) group = filters[groupKey]

  let nationalityKey = Object.keys(filters).find((d)=>d.indexOf('nationality')>=0)
  if(nationalityKey) nationality = filters[nationalityKey]

  //VERY UGLY:
  let base_url
  if(id.indexOf('evol')>=0) base_url = '/ind/evolutive'
  else base_url = '/ind/data'

  //NODE INFO
  let node = options.node ? options.node : store.state.nodeInfo
  let params = {
    indId: id,
    glk: node.glk,
    zoneId: node.id,
    timeScale: filters.timeScale || 'DAYS7',
    sector: sector,
    group: group,
    nationality: nationality,
    date: filters.current_date
  }

  let axiosConfig = {
    reqId: id+(options.jumpOnError?'_jump':''),
    avoidCancel: options.avoidCancel
  }
  
  // ALL DATA FAKE!!!!
  // ONLY WORKS WITH "España COUNTRY" (-1311341)y "Barcelona PROVINCE" (-349035)
  /*return axios.get(
    `./static/data/ind_data/${id}_${params.zoneId}.json`
  ).then((response)=> response.data)
  */
  let query = objToQuery(params)
  
  // UNCOMENT TO ACUTALLY USE CACHES!
  if(cachedDatas[query]) return new Promise((res)=>{
    return res(cachedDatas[query])
  })
  return cancelableInstance
    .get( process.env.VUE_APP_API_URL+`${base_url}?${query}`,axiosConfig)
    .then(response => {
      if(response){
        console.log(`API -----> data received for ${id} / ${store.state.nodeInfo.glk}`)
        console.log("API ----------> response:",response)
      }
      cachedDatas[query] = response && response.data
      return cachedDatas[query]
    })
    // .catch((e)=>{ //para coger el json
    //    return axios.get(
    //     `./static/data/ind_data/${id}.json`
    //   ).then((response)=> response.data)
    // })
    // catch => set to "null" and what?
    .catch(function(e){
      // if(e.response && id==='ind_trust' && !sector) {
      if(e.response && options.jumpOnError && !sector) {
        let parentInfo = {glk: store.state.nodeInfo.parent_glk,zoneId:store.state.nodeInfo.parent_id }
        // console.log("No data for this node.",store.state.nodeInfo.glk,"Will jump to parent:", parentInfo.glk)
        console.log(`API -----> No data for ${id} / ${store.state.nodeInfo.glk}`)

        if(!parentInfo.zoneId || parentInfo.zoneId === store.state.nodeInfo.id) {
          console.warn("Will not jump because parent is self or has no parent")
          return null
        }

        if(!store.state.redirectOrigin) store.dispatch('setRedirectOrigin',store.state.nodeInfo)

        store.dispatch('loadNodeInfo', parentInfo).then(function(){
          store.dispatch('loadNodeFilters', {...parentInfo, date: params.date}).then(function(){
            // return getIndicatorData(id,filters)
          })
        })
        // throw 'reloading'
      }
      else {
        return null
      }
      // else throw('no-data')
    })

}

export default {
  searchLocation(query) {
    let axiosConfig = {
      reqId: 'searchNode',
      avoidCancel: false
    }
    return cancelableInstance
    .get(
      process.env.VUE_APP_API_URL + '/map/search',
      {
        params: {
          query: query
        }
      },
      axiosConfig
    )
    .then(response => {
      return response.data
    })
  },

  getIndicatorList () {
    return Promise.resolve(
      [{
        "order": 1,
        "id": "trust"
      }, {
        "order": 2,
        "id": "pulse"
      }, {
        "order": 3,
        "id": "sector_evol"
      }, {
        "order": 4,
        "id": "sector_ranking"
      }, 
      {
        "order": 5,
        "id": "digital_ranking"
      },
      {
        "order": 6,
        "id": "digital_evol_ratio"
      },
      {
        "order": 7,
        "id": "tourism_ranking"
      }, {
        "order": 8,
        "id": "avg_ticket"
      }
    ]
    );
    /*return axios
    .get(
      './static/data/ind_list.json'
    ).
    .then(response => {
      return response.data
    })*/
  },

  getNodeInfo (params) {
    return axios
    .get(
      process.env.VUE_APP_API_URL + '/map/node',
      {
        params: params
      }
    )
    .then(response => {
      return response.data
    })
  },

  getNodeFilters (params) {
    return axios
    .get(
      process.env.VUE_APP_API_URL + '/ind/filters',
      {
        params: params
      }
    )
    .then(response => {
      return response.data
    })
  },

  getIndicatorData
}